










import { antiShake } from "@/common/decorator";
import Native from "@/common/Native";
import { Component, Vue } from "vue-property-decorator";
@Component
export default class Header extends Vue {
  back() {
    if (Native.isOpenInApp()) {
      Native.close();
    } else {
      this.$router.back();
    }
  }

  @antiShake(1000)
  share() {
    Native.shareApp();
  }
}
